import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import userQuery from 'graphql/users/single-query.graphql';
import { firebaseApp } from '../firebase';
import { useHistory } from 'react-router-dom';
import axios from '../utils/axios';
import { PATHS } from '../../components/main/paths';
import { environments } from '../utils/environments';
import * as Sentry from '@sentry/react';

function getCustomToken() {
  const token = localStorage.getItem('cofe-district:id_token');

  if (!token) return Promise.reject();

  return axios.get(`${environments.apiUrl}/firebase-custom-token`);
}

export function useUser() {
  const history = useHistory();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [loadUser, { data, error }] = useLazyQuery(userQuery);

  useEffect(() => {
    if (error) {
      Sentry.captureMessage(error.message);
    }
  }, [error]);

  useEffect(() => {
    if (!data) return;

    const { admin } = data;
    if (!admin?.roles?.includes('CSE')) {
      setUser(admin);
      setLoading(false);
      return;
    }

    getCustomToken().then(({ data: { customToken } }) => {
      history.push({
        pathname: PATHS.AUTHENTICATION.LOGIN,
        search: `?custom_token=${customToken}`,
      });
    });
    // location.href = `${process.env.VENDOR_URL}`;
  }, [data]);

  useEffect(() => {
    return firebaseApp.auth().onAuthStateChanged(user => {
      if (!user) {
        setUser(null);
        setLoading(false);
        return;
      }

      loadUser({ variables: { email: user.email } });
    });
  }, [history]);

  return { loading, user };
}
